/**
 * @memberof data-references
 * @enum {string}
 * @property {string} SYSTEM
 * @property {string} CUSTOMER
 */
var DataReferenceQueryPatternType;
(function (DataReferenceQueryPatternType) {
    DataReferenceQueryPatternType["SYSTEM"] = "system";
    DataReferenceQueryPatternType["CUSTOMER"] = "user";
})(DataReferenceQueryPatternType || (DataReferenceQueryPatternType = {}));
DataReferenceQueryPatternType[DataReferenceQueryPatternType.CUSTOMER] = DataReferenceQueryPatternType.CUSTOMER;
DataReferenceQueryPatternType[DataReferenceQueryPatternType.SYSTEM] = DataReferenceQueryPatternType.SYSTEM;
export default DataReferenceQueryPatternType;
